/**
 * @module components\ghTable\dataTable\dataRow\dataCell\imageCell
 */
import Vue from "vue";
import Component from "vue-class-component";
import DataCellBase from "../dataCellBase";
import { API_BASE_URL } from "@/utils/conf";

@Component
export default class ImageCell extends DataCellBase {
  private get source() {
    let path = this.header.source ? this.header.source : "api/files";
    let source = API_BASE_URL + path;
    if (this.value) {
      return source + "/" + this.value;
    }
    return "";
  }
}
